(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbDynamicScriptResolver", [], factory);
	else if(typeof exports === 'object')
		exports["sbDynamicScriptResolver"] = factory();
	else
		root["sbDynamicScriptResolver"] = factory();
})(window, function() {
return 